









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

import Field from '@/shared/components/field.component.vue';

import round from '@/shared/filters/round.filter.ts';
import formatDate from '@/shared/filters/formatDate.filter.ts';

@Component({
  components: {
    Field,
  },
  computed: {
    ...mapGetters({
      currentBudget: 'getCurrentBudgetAcceptance',
      budgetTotalPrice: 'getCurrentBudgetAcceptanceTotalPrice',
    }),
  },
  filters: {
    formatDate,
    round,
  },
})
export default class FeesInfo extends Vue {
  @Prop({ default: false }) private hideTotal!: boolean;
  @Prop({ default: false }) private squad!: boolean;

  private currentBudget!: any;
  private budgetTotalPrice!: any;

  get numberFeeCellClass() {
    let cellClass = '2/12--desktop 1/2--tablet 1/1--mobile';
    if (this.hideTotal) {
      cellClass = '3/12--desktop  1/2--tablet 1/1--mobile';
    }
    return cellClass;
  }

  get feeCellClass() {
    let cellClass = '8/12--desktop 1/1--tablet 1/1--mobile';
    if (this.hideTotal) {
      cellClass = '9/12--desktop 1/1--tablet 1/1--mobile';
    }
    return cellClass;
  }
}
